import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  style: {"width":"45rem","max-width":"80vw","max-height":"25rem"},
  class: "relative edit-body overflow-y-auto px-6 pt-4 pb-6"
}
const _hoisted_2 = { class: "text-14px xxl:text-14px text-gray-lp-800" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Pastikan selalu data yang Anda masukkan benar dan sesuai dengan filenya. Ikuti langsung cara mengisi template bulk upload ")
const _hoisted_4 = { class: "flex flex- justify-end mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadFile = _resolveComponent("UploadFile")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_button_outline = _resolveComponent("button-outline")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    onReset: _ctx.onReset,
    modelValue: _ctx.showFormUpdate,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.showFormUpdate = $event)),
    persistent: "",
    title: "Bulk Clearance",
    customBody: "py-3"
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("p", _hoisted_2, [
          _hoisted_3,
          _createVNode("span", {
            class: "text-red-lp-100 font-bold cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (
            _ctx.downloadTemplate(
              'https://prd-genesis.s3.ap-southeast-1.amazonaws.com/bulk/template/update_clearance.csv',
              'update_clearance',
              ''
            )
          ))
          }, " disini ")
        ]),
        _createVNode(_component_DataWrapper, {
          label: "Berkas STT Clearance",
          class: "mt-4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_UploadFile, {
              modelValue: _ctx.archiveFile,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.archiveFile = $event)),
              isClear: _ctx.isClearFile,
              "onUpdate:isClear": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isClearFile = $event)),
              statusReset: _ctx.statusReset,
              type: "csv",
              titleChange: "Ubah Berkas",
              maxRows: 100000
            }, null, 8, ["modelValue", "isClear", "statusReset"])
          ]),
          _: 1
        }),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_button_outline, {
            custom: "bg-white px-4 border border-red-lp-100 text-red-lp-200 mr-4",
            title: "Kembali",
            onClick: _ctx.onReset
          }, null, 8, ["onClick"]),
          _createVNode(_component_button_fill, {
            custom: "px-4 bg-red-lp-200",
            title: "Upload File",
            isDisabled: _ctx.isDisabled,
            onClick: _ctx.popupConfirmation
          }, null, 8, ["isDisabled", "onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onReset", "modelValue"]))
}